export const sortPriorityColumns = (priorityColumns, columns) =>
    columns.sort((a, b) => {
        const indexA = priorityColumns.indexOf(a.headerName);
        const indexB = priorityColumns.indexOf(b.headerName);

        const largeIndex = priorityColumns.length + 1000;
        const normalizedIndexA = indexA === -1 ? largeIndex : indexA;
        const normalizedIndexB = indexB === -1 ? largeIndex : indexB;

        return normalizedIndexA - normalizedIndexB;
    });
